module.exports = __webpack_public_path__ + "static/media/Mask Group.c85d01c6.png";